import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { fmtNum } from '@/lib/api';
import { MapView } from '@/components/MapView';
import { Loading, SectionTitle, StatusBadge, EmptyState } from '@/components/Shared';
import { Truck } from 'lucide-react';

export default function AdminLiveMap() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const timer = useRef(null);
  const load = () => api.get('/admin/active-deliveries').then((r) => setItems(r.data));
  useEffect(() => { load(); timer.current = setInterval(load, 5000); return () => clearInterval(timer.current); }, []);
  if (!items) return <Loading />;
  const markers = items.map((i) => ({ lat: i.driver_position.lat, lng: i.driver_position.lng, label: `${i.driver_name} → ${i.customer_name}` }));
  return (
    <div className="space-y-4">
      <SectionTitle>Live Delivery Tracking</SectionTitle>
      {items.length === 0 ? <EmptyState title="No active deliveries" desc="Active driver locations appear here in real-time." icon={Truck} /> : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-2"><MapView markers={markers} destination={items[0]?.destination} height="520px" /></div>
          <div className="space-y-2">
            {items.map((i) => (
              <div key={i.order_id} className="rounded-xl border border-border bg-card p-3 cursor-pointer hover:shadow-md" onClick={() => nav(`/admin/orders/${i.order_id}`)} data-testid={`live-order-${i.order_no}`}>
                <div className="flex items-center justify-between"><p className="font-medium text-sm">{i.order_no}</p><StatusBadge status={i.status} label={i.status_label} /></div>
                <p className="text-sm mt-1">{i.customer_name}</p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground mt-1"><Truck className="h-3.5 w-3.5" />{i.driver_name} · {i.vehicle_number} · {fmtNum(i.qty)}L</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
